import React from 'react'
import 'antd/dist/antd.min.css'
import { Modal, Form, Input, notification, DatePicker, message } from 'antd'
import { orderByRemitter } from "../../../api/console/order/Order"
import intl from "react-intl-universal"
import UploadFile from "../../../components/upload/UploadFile"

const { TextArea } = Input

const layout = {
    labelWrap: true,
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 14,
    },
}


const config = {
    rules: [
        {
            type: 'object',
            required: true,
            message: 'Please select time!',
        },
    ],
}


class PayModel extends React.Component {

    form = React.createRef();

    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            cateDisabled: false,
            fileList: [],
            detail: this.props.detail
        }
        this.fileListRef = React.createRef()

        this.handleModalOkClick = this.handleModalOkClick.bind(this)
        this.submitData = this.submitData.bind(this)
        this.showModal = this.showModal.bind(this)
        this.hideModal = this.hideModal.bind(this)
        this.onReset = this.onReset.bind(this)
    }

    handleModalOkClick () {
        this.form.current.submit()
    }

    // 发送ajax请求
    submitData (params) {
        params['order_id'] = this.state.detail.id

        params.remittance_url = []
        let fileList = this.fileListRef?.current?.state?.fileList
        fileList.map((file) => (
            params.remittance_url.push(file.response)
        ))

        if (params.remittance_url.length === 0) {
            message.warning(intl.get('order.pay_modal_img_message'))
            return
        }
        params['remittance_time'] = params['remittance_time'].format('YYYY-MM-DD')
        orderByRemitter(params).then((res) => {
            // console.log("get projects response:", res);
            if (res.code === 0) {
                notification.success({
                    message: 'Success',
                    description: res.msg,
                })
                this.hideModal()
                // 执行回调函数
                this.props?.callback?.()

            }
        }, (error) => {
            console.log("create failed!")
        }
        )
    };

    render () {
        return this.hasAuthCreate()
    }


    hasAuthCreate () {

        return (
            this.state.detail &&
            <>
                <Modal
                    title={intl.get('order.pay_modal_title')}
                    width={700}
                    visible={this.state.visible}
                    onOk={this.handleModalOkClick}
                    onCancel={this.hideModal}
                    okText={intl.get('console.m_p_ok')}
                    cancelText={intl.get('console.m_p_cancel')}>

                    <Form {...layout} ref={this.form} name="project" onFinish={this.submitData}>

                        <Form.Item
                            name="name"
                            label={intl.get('order.pay_modal_name')}
                            rules={[
                                {
                                    required: true,
                                    message: intl.get('order.pay_modal_name_message'),
                                },
                            ]}>
                            <Input placeholder={intl.get('order.pay_modal_name_message')} />
                        </Form.Item>
                        <Form.Item
                            name="bank_account"
                            label={intl.get('order.pay_modal_bc')}
                            rules={[
                                {
                                    required: true,
                                    message: intl.get('order.pay_modal_bc_message'),
                                },
                            ]}>
                            <Input placeholder={intl.get('order.pay_modal_bc_message')} />
                        </Form.Item>
                        <Form.Item
                            name="bank"
                            label={intl.get('order.pay_modal_bank')}
                            rules={[
                                {
                                    required: true,
                                    message: intl.get('order.pay_modal_bank_message'),
                                },
                            ]}>
                            <Input placeholder={intl.get('order.pay_modal_bank_message')} />
                        </Form.Item>
                        <Form.Item
                            name="phone"
                            label={intl.get('order.pay_modal_phone')}
                            rules={[
                                {
                                    required: true,
                                    message: intl.get('order.pay_modal_phone_message'),
                                },
                            ]}>
                            <Input placeholder={intl.get('order.pay_modal_phone_message')} />
                        </Form.Item>
                        <Form.Item
                            name="amount"
                            label={intl.get('order.pay_modal_amount')}>
                            <div>{this.state.detail.amount}</div>
                        </Form.Item>

                        <Form.Item
                            name="remittance_time"
                            label={intl.get('order.pay_modal_time')}
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <DatePicker placeholder={intl.get('order.pay_modal_time')} {...config} />
                        </Form.Item>

                        <Form.Item
                            name="remark"
                            label={intl.get('order.pay_modal_remark')}>

                            <TextArea rows={3} placeholder={intl.get('order.pay_modal_remark_hd')} />
                        </Form.Item>
                        <Form.Item
                            name="remittance_img"
                            label={<span><span style={{
                                display: "inline-block",
                                marginRight: "4px",
                                color: "#ff4d4f",
                                fontSize: "14px",
                                fontFamily: "SimSun, sans-serif",
                                lineHeight: 1,
                                content: '*'
                            }}>*</span> {intl.get('order.pay_modal_img')}</span>}
                            rules={[
                                {
                                    required: false,
                                },
                            ]}>

                            <UploadFile ref={this.fileListRef} />
                        </Form.Item>

                        <div className="font-14-l22-w400" style={{ paddingLeft: "100px" }}>
                            <div>{intl.get('order.pay_modal_tips')}</div>
                            <ul>
                                <li>{intl.get('order.pay_modal_tip1')}</li>
                                <li>{intl.get('order.pay_modal_tip2')}</li>
                            </ul>
                        </div>

                    </Form>

                </Modal>
            </>
        )
    }


    onReset () {
        this.form.resetFields()
    };

    showModal () {
        let that = this
        this.setState({
            visible: true,
        }, function () {
            that.form?.current?.setFieldsValue?.()
            that.setState({
                cateDisabled: true,
            })
        })
    };

    hideModal () {
        this.setState({
            visible: false,
        })
    };
}


export default PayModel


